let months = [31, 30, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export default function getMonthLength(obj) {
  return months[obj.getMonth()];
}
